/**
 * Общие для всех страниц скрипты
 */
import("./main");

/**
 * Данный скрипт реализовывает необходимый функционал страниц каталога
 */
$(() => {
    // Делаем респонсив таблицы - оборачиваем в специальный див, который можно двигать внутри
    $(".styled-content table , .redactor-table, .accordion__box table").wrap(
        '<div class="table-box-parent"><div class="table-box"></div></div>',
    );

    $(".filter-nav").removeAttr("style");
});

/**
 * Загрузка дополнительных данных по кнопке "Показать больше в сайдбаре"
 */
$(document).on("click", ".side-menu__more", function () {
    import("./components/sideMenuLoadMore").then((module) => {
        module.sideMenuLoadMore($(this));
    });
});

/**
 *Подгрузка списка программ при наведение на группу в сайдбаре
 */
$(".side-menu__item.has-program1").each((index, item) => {
    $(item).on("mouseenter", function () {
        import("./components/fetchProgramsOnHover").then((module) => {
            module.fetchProgramsOnHover($(this));
        });
    });
});

/**
 * Загрузка отдельно таблицы программ для блока школы в каталоге
 * @param {*} placeholder
 * @param {*} id
 */
window.loadProgramTable = function (link, id) {
    import("./components/loadSchoolPrograms").then((module) => {
        module.default(link, id);
    });
};

/**
 * Клик по селектору фильтров в мобильной версии
 */
$(document).on("click", ".filter-nav__title", function (e) {
    import("./components/filterNavSelect").then((module) => {
        module.handleFilterNavSelect($(this));
    });
});

/**
 * Управление показом tooltip
 */
$(document).on(
    "mouseenter focus mouseleave blur",
    ".camp__info-icon, [data-title][data-tooltip], [data-title]:not(.daterangepicker [data-title])",
    function (e) {
        import("./components/handleTooltip").then((module) => {
            module.default($(this), e);
        });
    },
);

/**
 * Раскрытие программ школ в каталоге
 */
$(document).on("click", ".program__all", function (e) {
    e.preventDefault();

    import("./components/showAllSchoolPrograms").then((module) => {
        module.default($(this));
    });
});

/**
 * Загрузка раскрывающихся меню в сайдбаре
 */
$(document).on("click", function (e) {
    let target = $(e.target);

    /**
     * Загрузка FAQ в сайдбаре по клику на заголовок виджета
     */
    if (
        target.hasClass("action--side-load-faq") ||
        target.closest(".action--side-load-faq").length !== 0
    ) {
        if (!target.hasClass("action--side-load-faq")) {
            target = target.closest(".action--side-load-faq");
        }

        import("./components/sidebarLoadFaq").then((module) => {
            module.default(target);
        });
    }

    /**
     * Загрузка articles в сайдбаре по клику на заголовок виджета
     */
    if (
        target.hasClass("action--side-load-post") ||
        target.closest(".action--side-load-post").length !== 0
    ) {
        if (!target.hasClass("action--side-load-post")) {
            target = target.closest(".action--side-load-post");
        }

        import("./components/sidebarLoadPost").then((module) => {
            module.default(target);
        });
    }
});

window.onload = () => {
    // Базовые настройки IntersectionObserver
    const options = {
        // Родитель целевого элемента
        root: null,
        // Отступ
        rootMargin: "0px",
        // Процент пересечения целевого элемента
        threshold: 0.1,
    };

    // Определяем наблюдателя
    const observer = new IntersectionObserver((entries, observer) => {
        // Для каждого входимого элемента
        entries.forEach((entry) => {
            // Если элемент появился на экране в зоне видимости
            if (entry.isIntersecting) {
                console.log("intersection with", entry.target.classList);

                if (entry.target.classList.contains("review")) {
                    // Загружаем скрипт комментариев
                    import("./components/newComments");
                }

                if (entry.target.classList.contains("result__map")) {
                    // Инициализируем карту для страницы каталога
                    import("./components/scrollTo").then(() => {
                        import("./components/catalogMap").then(() => {
                            console.log("catalog map initialized");
                        });
                    });
                }

                // Для формы "Подписаться"
                if (entry.target.classList.contains("subscription")) {
                    let form = $(entry.target);

                    if (!form.is("form")) {
                        form = form.find("form");
                    }

                    import("./components/newFormsLoader").then(
                        ({ newFormsLoader }) => {
                            newFormsLoader().then((module) => {
                                const { newForms } = module;

                                form.on("submit", function (e) {
                                    e.preventDefault();
                                    e.stopImmediatePropagation();
                                    e.stopPropagation();

                                    newForms.defaultFormHandle(e, {
                                        done: () =>
                                            import("./components/localizedUrl").then(
                                                ({ getLocalizedUrl }) => {
                                                    setTimeout(function () {
                                                        const url =
                                                            getLocalizedUrl(
                                                                "/thanks/",
                                                            );

                                                        window.location.href =
                                                            url;
                                                    }, 0);
                                                },
                                            ),
                                        showSuccessModal: false,
                                    });
                                });
                            });
                        },
                    );
                }
            }
        });
    }, options);

    // Определяем наблюдаемые элементы
    const observedItems = document.querySelectorAll(
        ".review, .result__map, .subscription",
    );

    // К каждому наблюдаемому элементу
    observedItems.forEach((form) => {
        // подключаем IntersectionObserver
        observer.observe(form);
    });
};
